import { capitalize } from "../../../components/helpers/capitalize";

export const convertCategory = (categories) => {
  let convertedCategories = [
    {
      value: 0,
      label: "Semua",
    },
  ];

  if (!categories || !categories.length) return [];

  categories.forEach((category) => {
    convertedCategories.push({
      value: category.id,
      label: capitalize(category.name),
    });
  });
  return convertedCategories;
};
